(() => {
  const initProductRail = (landing) => {
    const rail = landing.querySelector('[data-gd-line-product-rail]');
    const controls = landing.querySelector('[data-gd-line-controls]');
    if (!rail || !controls || rail.dataset.initialized) return;
    rail.dataset.initialized = 'true';
    const cards = [...rail.querySelectorAll('.gd-line-landing__product')];
    if (cards.length < 2) return;
    const prev = controls.querySelector('[data-gd-line-prev]');
    const next = controls.querySelector('[data-gd-line-next]');
    const counter = controls.querySelector('[data-gd-line-count]');
    if (!prev || !next || !counter) return;
    controls.hidden = false;
    rail.classList.add('is-ready');
    let current = 0;
    const leftOf = (card) => card.offsetLeft - cards[0].offsetLeft;
    const showState = () => {
      prev.disabled = current === 0;
      next.disabled = current === cards.length - 1;
      counter.textContent = `Produto ${current + 1} de ${cards.length}`;
    };
    const sync = () => {
      const nearest = cards.reduce((closest, card, index) =>
        Math.abs(leftOf(card) - rail.scrollLeft) < Math.abs(leftOf(cards[closest]) - rail.scrollLeft) ? index : closest, 0);
      if (nearest !== current) {
        current = nearest;
        cards.forEach((card, index) => {
          if (index !== current) card.querySelectorAll?.('.gd-line-landing__details[open]').forEach((details) => { details.open = false; });
        });
      }
      showState();
    };
    const go = (index) => {
      current = Math.min(cards.length - 1, Math.max(0, index));
      showState();
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      rail.scrollTo({ left: leftOf(cards[current]), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    rail.addEventListener('scroll', sync, { passive: true });
    rail.addEventListener('keydown', (event) => {
      if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      go(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    sync();
  };

  const initRitual = (landing) => {
    const ritual = landing.querySelector('[data-gd-ritual]');
    if (!ritual || ritual.dataset.initialized) return;
    ritual.dataset.initialized = 'true';
    const steps = [...ritual.querySelectorAll('li')];
    if (steps.length !== 3 || !('IntersectionObserver' in window)) return;
    const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    let timer = null;
    let inView = false;
    let current = 0;
    const stop = () => {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
      steps.forEach((step) => step.classList.remove('is-active'));
    };
    const start = () => {
      if (!inView || document.hidden || motion?.matches || timer !== null) return;
      current = 0;
      steps.forEach((step, index) => step.classList.toggle('is-active', index === current));
      timer = window.setInterval(() => {
        current = (current + 1) % steps.length;
        steps.forEach((step, index) => step.classList.toggle('is-active', index === current));
      }, 1800);
    };
    const observer = new window.IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting);
      if (inView) start();
      else stop();
    }, { threshold: 0.25 });
    observer.observe(ritual);
    const onVisibility = () => { if (document.hidden) stop(); else start(); };
    const onMotion = () => { if (motion.matches) stop(); else start(); };
    document.addEventListener('visibilitychange', onVisibility);
    motion?.addEventListener?.('change', onMotion);
    ritual.gdCleanup = () => {
      stop();
      observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      motion?.removeEventListener?.('change', onMotion);
    };
  };

  const init = (root) => {
    root.querySelectorAll('.gd-line-landing').forEach((landing) => {
      initProductRail(landing);
      initRitual(landing);
      const sticky = landing.querySelector('.gd-line-landing__sticky');
      if (!sticky || sticky.dataset.initialized) return;
      sticky.dataset.initialized = 'true';
      const targets = [
        landing.querySelector('[data-gd-line-hero-cta]'),
        landing.querySelector('[data-gd-line-final-cta]'),
      ].filter(Boolean);
      const visible = new Map(targets.map((target) => [target, false]));
      const sync = () => {
        const hide = [...visible.values()].some(Boolean);
        sticky.classList.toggle('is-hidden', hide);
        document.body.classList.toggle('gd-line-sticky-visible', !hide);
      };
      if (!('IntersectionObserver' in window)) {
        sticky.classList.add('is-hidden');
        return;
      }
      const observer = new window.IntersectionObserver((entries) => {
        entries.forEach((entry) => visible.set(entry.target, entry.isIntersecting));
        sync();
      }, { threshold: 0 });
      targets.forEach((target) => observer.observe(target));
      sync();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-gd-ritual]').forEach((ritual) => ritual.gdCleanup?.());
    document.body.classList.remove('gd-line-sticky-visible');
  });
})();